module.exports = __webpack_public_path__ + "img/77.dc706519.jpg";